import Breadcrumb from './components/Breadcrumb';
import { useBreadcrumbs } from './useBreadcrumbs';
import { Bones } from '../Bones';
import type { ReactNode } from 'react';

export const BreadcrumbNav = ({ children }: { children: ReactNode }) => {
  const { breadcrumbs, status } = useBreadcrumbs();

  return (
    <div>
      <div className="grid select-none grid-cols-[minmax(0,1fr)_auto] items-baseline justify-between gap-x-x1_5 gap-y-x0_5 text-softer">
        {/* TODO: Breadcrumb: Expose custom li slot to style the crumbs directly 
      instead of using the arbitrary variants (`[&_*]:`) below */}
        <div className="[&_*]:gap-x0_5 [&_*]:text-tiny [&_*]:no-underline [&_a:focus]:text-soft">
          {status === 'success' ? (
            <Breadcrumb list={breadcrumbs} />
          ) : (
            <Bones className="max-w-[20ch]" />
          )}
        </div>
        <div className="text-right text-tiny min-[375px]:text-xs">
          {children ?? (
            // Zero whitespace character (avoid layout shift)
            <>&#8203;</>
          )}
        </div>
      </div>
    </div>
  );
};
